/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Quantity_Exceeds_DeliveredInputs */

const vi_error_return_quantity_exceeds_delivered = /** @type {(inputs: Error_Return_Quantity_Exceeds_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số trả của một dòng vượt số còn trả được (đã giao trừ các lần trả trước). Tải lại popup để lấy số mới.`)
};

/**

* @param {Error_Return_Quantity_Exceeds_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_quantity_exceeds_delivered = /** @type {((inputs?: Error_Return_Quantity_Exceeds_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Quantity_Exceeds_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_quantity_exceeds_delivered(inputs)
});